import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const DistanceCoveredPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [distanceLeftValues, setDistanceLeftValues] = useState([]);
  const [distanceRightValues, setDistanceRightValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let distance_hand_left = [];
    let distance_hand_right = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      distance_hand_left.push(recording.hasOwnProperty("distance_hand_left") ? recording.distance_hand_left : NaN);
      distance_hand_right.push(recording.hasOwnProperty("distance_hand_right") ? recording.distance_hand_right : NaN);
    });

    setPositions(positions);
    setDistanceLeftValues(distance_hand_left);
    setDistanceRightValues(distance_hand_right);

    return () => {
      setPositions([]);
      setDistanceLeftValues([]);
      setDistanceRightValues([]);
    };
  }, [recordings]);

  const distanceData = {
    labels: positions,
    datasets: [
      {
        label: t("reports_distanceCoveredGraphic_legend1"),
        data: distanceLeftValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        label: t("reports_distanceCoveredGraphic_legend2"),
        data: distanceRightValues,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_distanceCovered")}
        Type={Line}
        data={distanceData}
        axisY={t("reports_distanceCovered")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_distanceCoveredDescription_ClinicAndHome")}
      />
    </GraphicContainer>
  );
});

export default DistanceCoveredPlot;
